import { useNavigate } from "react-router-dom";
import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import moment from "moment-timezone";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";
import LoadingScreen from "../../component/LoadingScreen";

const CreateTerminationLetter = () => {
  const navigate = useNavigate();
  const [terminationDetail, setTerminationDetail] = useState({ terminationItemlist: [] ,  terminationFeedbackList: []});

  let [token, setToken] = useState("");
  const resource = "create-internal-termination-letter";
  const [internalName, setInternalName] = useState("");
  const [internalEmail, setInternalEmail] = useState("");
  const [terminationDate, setTerminationDate] = useState("");
  const [internalTerminationLetterDate, setInternalTerminationLetterDate] = useState("");
  const [currentDate, setCurrentDate] = useState("");
  const [error, setError] = useState(null);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [openFailSubmit, setOpenFailSubmit] = useState(false);
  const [openFailConfirm, setOpenFailConfirm] = useState(false);
  const [openConfirmSucces, setOpenConfirmSucces] = useState(false);
  const [to, setTo] = useState("");
  const [company, setCompany] = useState("");
  const [re, setRe] = useState("Termination Cross Connect Service");
  const [isDownloadActive, setIsDownloadActive] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [downloadUrl, setDownloadUrl] = useState("");
  const [fileName, setFileName] = useState("");



  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    setToken(storedToken);

    const checkSessionToken = async () => {
      try {
        const response = await fetch(
          `https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/check-session?token=${storedToken}&resource=${resource}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          setError(data.message || "Failed to fetch session token data");
          throw new Error(data.message || "Failed to fetch session token data");
        }

        // Parse response text as a boolean value
        const text = await response.text();
        const data = text === "true";

        if (data) {
        } else {
          window.alert("Session is invalid");
          navigate("/login");
        }
      } catch (error) {
        console.error("Fetch Error:", error.message);
        setError("Fetch Error: " + error.message);
      }
    };

    checkSessionToken();
  }, []);

  useEffect(() => {
    // Retrieve the token from local storage
    const storedToken = localStorage.getItem("token");
    setToken(storedToken);

    // Fetch internal data using the token
    const fetchInternalData = async () => {
      try {
        const response = await fetch(
          `https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/find-by-token?token=${storedToken}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        const data = await response.json();

        if (!response.ok) {
          setError(data.message || "Failed to fetch internal data");
          throw new Error(data.message || "Failed to fetch internal data");
        }

        setInternalName(data[0].xcp_internal_name);
        setInternalEmail(data[0].xcp_internal_email);
      } catch (error) {
        console.error("Fetch Error:", error.message);
        setError("Fetch Error: " + error.message);
      }
    };

    fetchInternalData();
  }, []);

  useEffect(() => {
    const currentDate = new Date().toISOString().split("T")[0];
    setCurrentDate(currentDate);
  }, []);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const terminationId = searchParams.get("param1");

  useEffect(() => {
    loadTerminationDetail(searchParams.get('param1'));
  },  []);

  const loadTerminationDetail = async (terminationId) => {
  try {       
  const result = await axios.get(`https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/termination/termination-detail?terminationId=${terminationId}`);
  const data = result.data;

  console.log("data " + JSON.stringify(data))
  
  const dateObject = new Date(data.xcp_internal_termination_letter_date);
  const newInternalTerminationLetterDate = dateObject.toISOString().split("T")[0];
  
    setTerminationDetail(data);
    setTerminationDate(data.termination_date)
    setCompany(data.company_name)
    

    if(data.xcp_internal_termination_letter_date !== null){
      setInternalTerminationLetterDate(newInternalTerminationLetterDate)
    } else {
      const currentDate = new Date().toISOString().split("T")[0];
      setInternalTerminationLetterDate (currentDate);
    }
  } catch (error) {
  console.error("Error loading termination list:", error);
  }
  };

  const handleConfirmation = async (event) => {
    event.preventDefault();

    const form = event.target.closest("form"); // Get form element
    const isValid = form.checkValidity();

    if (isValid) {
      // Form is valid, proceed with submission or further logic
      const buttonValue = event.target.querySelector(
        '[type="submit"]:focus'
      )?.value;
      if (buttonValue === "confirm") {
        handleConfirm();
      } else if (buttonValue === "submit") {
        setOpenConfirm(true);
      }
    } 
  };

  const handleClose = () => {
    setOpenConfirm(false);
    setOpenFailSubmit(false);
    setOpenConfirmSucces(false);
    setOpenFailConfirm(false);
  };

  function getDateTimeInUserTimeZone(date) {
    const userTimeZone = moment.tz.guess();
    // Get the current time in the user's local time zone
    const currentTime = moment.tz(userTimeZone).format("HH:mm:ss");

    // Combine the selected date with the current time
    const dateTimeInUserTimeZone = moment
      .tz(`${date}T${currentTime}`, userTimeZone)
      .format("YYYY-MM-DDTHH:mm:ss");

    return dateTimeInUserTimeZone;
  }

  const handleSubmit = async (event) => {
    const submitInternalTerminationLetter = {
      terminationId:terminationId,
      internalEmail: internalEmail,    
      currentDate: getDateTimeInUserTimeZone(currentDate)
    };

    try {
      const response = await fetch(
        "https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/termination/submit-internal-termination-letter",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(submitInternalTerminationLetter),
        }
      );

      const data = await response.json();
      const responseBody = JSON.parse(data.body);

      if (!response.ok) {
        throw new Error("Failed to submit Internal Termination Letter");
      }

      const { message } = responseBody;
      if (message == "success") {
        // Store the token in local storage
        localStorage.setItem("token", token);

        setOpenConfirm(false);
        setOpenSuccess(true);
      } else {
        setOpenConfirm(false);
        setOpenFailSubmit(true);
      }
    } catch (error) {
      setError("Submission Error: " + error.message);
      console.error("Submission Error:", error.message);
      setOpenConfirm(false);
      setOpenFailSubmit(true);
    }
  };

  const handleConfirm = async (event) => {
    setIsLoading(true);

    const confirmInternalTerminationLetter = {
      terminationId:terminationId,
      internalEmail: internalEmail,    
      terminationDate: terminationDate,
      internalTerminationLetterDate: getDateTimeInUserTimeZone(internalTerminationLetterDate),
      internalTerminationLetterPrepareBy: internalName, //internalName
      company:company,
      terminationItemList: []
    };

    terminationDetail.terminationItemlist.forEach((item) => {
      confirmInternalTerminationLetter.terminationItemList.push({
        cableId: item.cable_id,
        salesOrderNumber: item.sales_order_no
      })
    })

    try {
      const response = await fetch(
        "https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/termination/confirm-internal-termination-letter",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(confirmInternalTerminationLetter),
        }
      );

      const data = await response.json();
      const responseBody = JSON.parse(data.body);

      if (!response.ok) {
        throw new Error("Failed to confirm Internal Termination Letter");
      }

      const { message } = responseBody;
      const { downloadUrl } = responseBody;
      const { fileName } = responseBody;
      if (message == "success") {
        setIsDownloadActive(true);
        setOpenConfirmSucces(true);
        setDownloadUrl(downloadUrl);
        setFileName(fileName);
      } else {
        setOpenFailConfirm(true);
      }
    } catch (error) {
      setError("Submission Error: " + error.message);
      console.error("Submission Error:", error.message);
      setOpenFailConfirm(true);
    } finally {
      setIsLoading(false);
    }
  };

  function inputSuccess() {
    navigate("/termination-list");
  }

  const formatDate = (datetime) => {
    const date = new Date(datetime);
    const year = date.getUTCFullYear(); // Gunakan UTC
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Gunakan UTC
    const day = String(date.getUTCDate()).padStart(2, '0'); // Gunakan UTC
    return `${day}/${month}/${year}`;
  };

  const handleDownload = async () => {
    try {
      const response = await fetch(downloadUrl, {
        method: "GET", // Use GET to download the file
      });

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName); // Set the desired file name
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link); // Clean up after download
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  return (
    <div className="container-order-input">
      {isLoading && <LoadingScreen />}
      <Dialog open={openConfirm}>
        <DialogTitle>
          {"Are you sure you want to submit this Internal termination letter?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Clicking "Yes" will submit this Internal termination letter.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            No
          </Button>
          <Button onClick={handleSubmit} color="primary" autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openSuccess}>
        <DialogTitle>{"Internal termination letter submit successfully"}</DialogTitle>
        <DialogActions>
          <Button onClick={inputSuccess} color="primary" autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openFailSubmit}>
        <DialogTitle>{"Internal termination letter submit failed"}</DialogTitle>
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openFailConfirm}>
        <DialogTitle>{"Confirm Quotation Form  Failed"}</DialogTitle>
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openConfirmSucces}>
        <DialogTitle>{"Confirm Quotation Form successfully"}</DialogTitle>
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      <h1 className="main-title">Cross Connect Create Internal Termination Letter </h1>
      <form onSubmit={handleConfirmation}>
        <div className="box-two-part">
          <div className="requestor-information">
            <div className="title-order-input">
              <h5>Internal termination Letter Header</h5>
            </div>
            <div className="textbox-gray">
              <label>To</label>
              <input type="text" id="to" value={terminationDetail.termination_pic} required disabled />
            </div>
            <div className="textbox-gray">
              <label>Company</label>
              <input
                type="text"
                id="company"
                value={terminationDetail.company_name}
                required
                disabled
              />
            </div>
            <div className="textbox-gray">
              <label>Re</label>
              <input type="text" id="re" value={re} required disabled />
            </div>
          </div>

          <div className="destination-information">
            <div className="title-order-input">
              <h5 style={{ visibility: "hidden" }}>.</h5>
            </div>
            <div className="textbox">
              <label htmlFor="internalTerminationLetterDate">Termination Letter Date</label>
              <input
                type="date"
                value={internalTerminationLetterDate}
                onChange={(e) => setInternalTerminationLetterDate(e.target.value)}
                required
              />
            </div>
            <div className="textbox-gray">
              <label htmlFor="terminationDate">Termination Date</label>
              <input type="text" value={formatDate(terminationDetail.termination_date)} disabled/>
            </div>
            <div className="textbox-gray">
              <label>Prepared By</label>
              <input type="text" value={internalName} disabled />
            </div>
          </div>
        </div>

        {terminationDetail.terminationItemlist &&
          terminationDetail.terminationItemlist.length > 0 &&
          terminationDetail.terminationItemlist.map((termination, index) => (
            <div>
            <div className="title-order-input">
                  <h5>Termination Item ({index + 1})</h5>
                </div>
            <div className="box-two-part">
              <div className="requestor-information">        
                <div className="textbox-gray">
                        <label htmlFor="companyName">Cable Id</label>
                        <input type="text" value={termination.cable_id} disabled/>
                    </div>
              </div>

              <div className="destination-information">
                  <div className="textbox-gray">
                      <label htmlFor="salesOrderNumber">Sales Order Number</label>
                      <input type="text" value={termination.sales_order_no} disabled/>
                  </div>  
              </div>
            </div>
            </div>
          ))}

        <div className="box-two-part">
          <div className="requestor-information">
            <div className="button-group">
              <button
                className="btn-confirm"
                type="submit"
                name="action"
                value="confirm"
              >
                Confirm
              </button>

              {/* Conditionally render the download button */}
              {isDownloadActive && (
                <button
                  className="btn-download"
                  type="button"
                  onClick={handleDownload}
                >
                  Download
                </button>
              )}
              {isDownloadActive && (
                <button
                  className="btn-submit"
                  type="submit"
                  name="action"
                  value="submit"
                >
                  Submit
                </button>
              )}
            </div>
          </div>
          <div className="destination-information">
            <div className="title-order-input">
              <h5 style={{ visibility: "hidden" }}>.</h5>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default CreateTerminationLetter;
